export default {
  rates: {
    inflation: [],
    interest: [],
  },
};
